package com.kinoshazam

import androidx.compose.runtime.compositionLocalOf
import com.kinoshazam.model.AppLanguage

/** Must be [compositionLocalOf] so language changes invalidate string consumers on web. */
val LocalLocalization = compositionLocalOf { AppLanguage.EN }
